import {Client} from "../../autogenerate/api.generated.clients";

export const useUpdateCompressorEndUser = function () {
    return {
        updateCompressorEndUser: (frameSerialNumber: string, subOrganizationName: string) => new Client().compressor_UpdateEndUserForCompressor(frameSerialNumber, subOrganizationName)
    }
}